import styles from '/builds/sitegeist/bad-toelz-de/.build/releases/1/DistributionPackages/BadToelz.BadToelzDe/Resources/Private/Fusion/Presentation/ContentElements/Masonry/Item/Item.css';

export const prototypeName = '1Do09dQrJkcOK0312NxefzMxxPlZGAT9ArJr9L4PUGv3nR8R5gfqDND4eLvDSRv153bqMNU5KN3dZMdQ';
export {styles};